import { useContext } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import ChangePassword from '../Auth/ChangePassword'
import Login from '../Auth/Login'
import Register from '../Auth/Register'
import { UserContext } from '../Context/UserContext'
import Dashboard from '../Dashboard'
import CreateProfile from '../Dashboard/CreateProfile'
import CreateWallet from '../Dashboard/CreateWallet'
import EditProfile from '../Dashboard/EditProfile'
import Profile from '../Dashboard/Profile'
import TopupWallet from '../Dashboard/TopupWallet'
import Walletyan from '../Dashboard/Walletyan'
import Home from '../Home'
import FormOrder from '../Order/FormOrder'
import FormPayment from '../Order/FormPayment'
import ShopCart from '../Order/ShopCart'
import TableOrder from '../Order/TableOrder'
import Product from '../Products'
import CreateProduct from '../Products/CreateProduct'
import DetailProduct from '../Products/DetailProduct'
import ProductsTable from '../Products/ProductsTable'
import UpdateProduct from '../Products/UpdateProduct'

const Routes = () => {
    const[user] = useContext(UserContext)
    // let {id} = useParams();
    return (
        <Switch>
            <Route exact path="/">
                <Home/>
            </Route>
            <Route exact path="/product">
                <Product/>
            </Route>
            <Route exact path="/product/detail/:id">
                <DetailProduct/>
            </Route>
            <Route exact path="/login">
                {!user ? <Login/> : <Redirect to="/"/>}
            </Route>
            <Route exact path="/register">
                {!user ? <Register/> : <Redirect to="/"/>}
            </Route>
            <Route exact path="/dashboard">
                {user ? <Dashboard/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/walletyan">
                {user ? <Walletyan/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/profile">
                {user ? <Profile/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/profile/change-password">
                {user ? <ChangePassword/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/profile/edit">
                {user ? <EditProfile/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/profile/create">
                {user ? <CreateProfile/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/walletyan/create">
                {user ? <CreateWallet/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/walletyan/topup">
                {user ? <TopupWallet/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/cart">
                {user ? <ShopCart/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/payment">
                {user ? <FormPayment/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/create-order/:id">
                {user ? <FormOrder/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/table-order">
                {user ? <TableOrder/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/table-product">
                {user && user.username === "admin" ? <ProductsTable/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/table-product/create">
                {user && user.username === "admin" ? <CreateProduct/> : <Redirect to="/login"/>}
            </Route>
            <Route exact path="/table-product/edit/:id">
                {user && user.username === "admin" ? <UpdateProduct/> : <Redirect to="/login"/>}
            </Route>
        </Switch>
    )
}

export default Routes